import {
    CREATE_DEPARTMENT_TYPES,
    CREATE_DEPARTMENT_TYPES_SUCCESS,
    DELETE_DEPARTMENT_TYPES,
    DELETE_DEPARTMENT_TYPES_SUCCESS,
    GET_ALL_DEPARTMENT_TYPES,
    GET_ALL_DEPARTMENT_TYPES_SUCCESS,
    GET_DEPARTMENT_TYPES_BY_ID,
    GET_DEPARTMENT_TYPES_BY_ID_SUCCESS,
    UPDATE_DEPARTMENT_TYPES,
    UPDATE_DEPARTMENT_TYPES_SUCCESS,
    GET_DEPARTMENT_TYPES_FAILURE,
} from "../storeTypes";

/* ===================== GET BY ID ===================== */
export const getDepartmentDataById = (id) => ({
    type: GET_DEPARTMENT_TYPES_BY_ID,
    payload: id,
});

export const getDepartmentDataByIdSuccess = (payload) => ({
    type: GET_DEPARTMENT_TYPES_BY_ID_SUCCESS,
    payload,
});

/* ===================== GET ALL ===================== */
export const getAllDepartmentTypes = () => ({
    type: GET_ALL_DEPARTMENT_TYPES,
});

export const getAllDepartmentTypesSuccess = (payload) => ({
    type: GET_ALL_DEPARTMENT_TYPES_SUCCESS,
    payload,
});

/* ===================== CREATE ===================== */
export const createDepartmentTypes = (payload) => ({
    type: CREATE_DEPARTMENT_TYPES,
    payload,
});

export const createDepartmentTypesSuccess = (payload) => ({
    type: CREATE_DEPARTMENT_TYPES_SUCCESS,
    payload,
});

/* ===================== UPDATE ===================== */
export const updateDepartmentTypes = (id, data) => ({
    type: UPDATE_DEPARTMENT_TYPES,
    payload: {
        id,
        data,
    },
});


export const updateDepartmentTypesSuccess = (payload) => ({
    type: UPDATE_DEPARTMENT_TYPES_SUCCESS,
    payload,
});

/* ===================== DELETE ===================== */
export const deleteDepartmentTypes = (id) => ({
    type: DELETE_DEPARTMENT_TYPES,
    payload: id,
});

export const deleteDepartmentTypesSuccess = (id) => ({
    type: DELETE_DEPARTMENT_TYPES_SUCCESS,
    payload: id,
});

/* ===================== FAILURE ===================== */
export const departmentTypesFailure = (error) => ({
    type: GET_DEPARTMENT_TYPES_FAILURE,
    payload: { error },
});
